import BaseDrawerFeature from '@src/framework/workbench/common/feature/base-drawer-feature';
import { Feature } from '@tencent/workbench';
import type ChartManager from '@src/slide/application/service/chart-manager';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';

@Feature()
export class ChartDataEditorFeature extends BaseDrawerFeature {
    private chartManager: ChartManager;

    public constructor() {
        super();
        this.chartManager = (this.getAppServices() as IPcEditorAppServices).editableServiceLayer!.chartManager;
    }
    public openChartDataEditor(): void {
        const model = this.getSelectModel();
        this.chartManager.openChartDataEditor(model);
    }
}
